import React from 'react';
import { createRoot } from 'react-dom/client';
import { default as CookieConsentPopup } from '../../components/specific/CookieConsent/App';
import ManageCookiesLink from '../../components/specific/CookieConsent/CustomizeCookiePreferences/ManageCookiesLink';
import PropsExtractor from '../PropsExtractor';
import ChrPropTypes from '../ChrPropTypes';

export default class CookieConsentRenderer {
  static renderApp = (elementId) => {
    const node = document.getElementById(elementId);
    const root = createRoot(node);
    let dataFromElement = PropsExtractor.getForList(node, {
      "consentConstants": ChrPropTypes.object,
      "gaMeasurementId": ChrPropTypes.string,
      "assetS3Url": ChrPropTypes.string,
      "customCookiePolicy": ChrPropTypes.string,
      "cookiePolicyUrl": ChrPropTypes.string
    });
    dataFromElement.customCookiePolicy = (dataFromElement.customCookiePolicy === "true")

    const ComponentToRender = (elementId === "cjs-cookie-consent-popup") ? CookieConsentPopup : ManageCookiesLink;
    root.render(
      <ComponentToRender data={dataFromElement} />
    );
  };
}
